import React, { Fragment, useMemo } from 'react';

//MaterialUI
import { Link } from '@mui/material';

// Components
import { CardDetail, FormControll } from '@arredo/reactjs-ui';

const ShippingDetails = ({ shippingData, branches, order, warehouses }) => {
  const courier = shippingData.courier && shippingData.courier !== 'None' 
    ? shippingData.courier
    : '';

  const warehouse = useMemo(() => 
    warehouses?.find(w => w.id === shippingData.warehouseIdDestination)
 , [shippingData, warehouses]);

  return (
    <CardDetail 
      title={ shippingData.type } 
      subTitle={ courier }
      spacing={ 0 }
    >
      
      {
        shippingData.type === "Pickup" && !!warehouse &&
        <FormControll label='Sucursal de destino' value={warehouse.name} />
      }
      {
        shippingData.address &&
        <FormControll label='Direccion' value={ shippingData.address.fullAddress } />
      }
      {
        !!shippingData.amount &&
        <FormControll label='Monto' value={ `$ ${shippingData.amount}` || 0.00 } />
      }
            {order?.shippingData?.packageDatas.map((track, index) =>
      (
       <Fragment key={index}>
         <FormControll label='TrackingNumber' value={ track.trackingNumber} />
         <FormControll label='TrackingUrl' value={<Link href={track.trackingUrl} label='TrackingUrl' color="primary" target="_blank" rel="noreferrer">Link</Link>} />         

       </Fragment>
       )
      )}
    </CardDetail>
  )
}
export default ShippingDetails;